import React from 'react';
import cx from 'classnames';

import SectionHeader from '@marketing/components/section_header';

import HarvardLogo from './assets/harvard_logo.png';
import MITLogo from './assets/mit_logo.png';
import StanfordLogo from './assets/stanford_logo.png';
import WhartonLogo from './assets/wharton_logo.png';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l u-padding-V-xl" style={{ position: 'relative' }}>
      <SectionHeader
        reveal
        title="Magoosh students get into top schools"
      />

      <div className={cx(styles.schoolLogosContainer, 'd-flex gap-l flex-wrap')}>
        <img alt="Harvard Business School logo" height="85px" loading="lazy" src={HarvardLogo} width="200px" />
        <img alt="Stanford Graduate School of Business logo" height="85px" loading="lazy" src={StanfordLogo} width="200px" />
        <img alt="MIT Sloan School of Management logo" height="85px" loading="lazy" src={MITLogo} width="200px" />
        <img alt="The Wharton School logo" height="85px" loading="lazy" src={WhartonLogo} width="200px" />
      </div>
    </div>
  );
};
